import { render, staticRenderFns } from "./UserPlaylists.vue?vue&type=template&id=0a2cabac&scoped=true"
import script from "./UserPlaylists.vue?vue&type=script&lang=js"
export * from "./UserPlaylists.vue?vue&type=script&lang=js"
import style0 from "./UserPlaylists.vue?vue&type=style&index=0&id=0a2cabac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2cabac",
  null
  
)

export default component.exports